import React, { FunctionComponent } from "react";
import { Button } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import {
	colorGrayLight,
	grayMed,
	grayscaleBg,
	grayscaleBgHover,
	grayscaleText,
} from "../../styles/theme";

interface ChatSelectButtonProps {
	selected: boolean;
	onToggle: () => void;
}

const ChatSelectButton: FunctionComponent<ChatSelectButtonProps> = ({
	selected,
	onToggle,
}) => {
	return (
		<Button
			onClick={onToggle}
			aria-pressed={selected}
			aria-label={selected ? "Remove from chat" : "Add to chat"}
			startIcon={
				selected ? (
					<CheckIcon sx={{ width: 16, height: 16 }} />
				) : (
					<RadioButtonCheckedIcon
						sx={{ width: 16, height: 16, color: grayMed }}
					/>
				)
			}
			sx={{
				height: "32px",
				flexShrink: 0,
				minWidth: "auto",
				paddingInline: "12px",
				borderRadius: "999px",
				textTransform: "none",
				whiteSpace: "nowrap",
				fontSize: "13px",
				fontWeight: 600,
				color: grayscaleText,
				backgroundColor: selected ? grayscaleBgHover : "transparent",
				border: `1px solid ${selected ? grayscaleBgHover : colorGrayLight}`,
				transition: "background-color 0.15s ease, border-color 0.15s ease",
				"& .MuiButton-startIcon": {
					marginRight: "6px",
					marginLeft: 0,
				},
				"&:hover": {
					backgroundColor: selected ? grayscaleBgHover : grayscaleBg,
					borderColor: selected ? grayscaleBgHover : grayMed,
				},
				"@media (max-width: 380px)": {
					paddingInline: "8px",
					"& .chatSelectLabel": { display: "none" },
					"& .MuiButton-startIcon": { marginRight: 0 },
				},
			}}
		>
			<span className="chatSelectLabel">
				{selected ? "Added" : "Add to chat"}
			</span>
		</Button>
	);
};

export default ChatSelectButton;
